import { useCanUser } from 'features/can-user/canUser';
import { Interstitial } from '@prism/library';
import PrivateRouteNoLdap from './PrivateRoute_NoLDAP';

export default function PrivateRouteAccess({ children }) {
  const canUser_AccessAMSUI = useCanUser('AMSUI_Access');

  console.groupCollapsed('PrivateRoute');
  console.log('canUser_AccessAMSUI', canUser_AccessAMSUI);
  console.groupEnd();

  if (canUser_AccessAMSUI === undefined) {
    return <Interstitial />;
  }
  if (canUser_AccessAMSUI === false) {
    return <PrivateRouteNoLdap />;
  }
  if (canUser_AccessAMSUI === true) {
    return children;
  }
}
